import { Link, Stack, Typography } from '@mui/material';

import CenteredScreen from '@/karehero-app/onboarding/current-flow/CenteredScreen';
import {
  AI_CONSENT,
  AI_CONSENT_ON_CONTINUE,
} from '@/karehero-app/tell-us-once/intake/content';
import { type Account } from '@/karehero-app/access/AccountBar';

// "You're in" and "Before we start" folded into one screen: the consent rides
// on Continue as a line above it instead of taking a screen of its own.
//
// A take on AccessVerifiedScreen rather than a replacement for it. Both stay
// reachable so the two shapes can be read against each other — the split pair
// asks for an answer, this one takes the press as the answer.
//
// The policy link is the same lead and label AiConsentScreen uses, so folding
// the consent in does not quietly drop the way out to the document behind it.
//
// It has no decline path by construction, so `ai-consent-declined` is
// unreachable from here.
const AccessVerifiedConsentScreen = ({
  onContinue,
  account,
}: {
  onContinue: () => void;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => (
  <CenteredScreen
    account={account}
    title="You're in"
    description="Your access is confirmed. Next we'll ask a few quick questions to set up your account and shape the right support for you. It takes about a minute."
    actionNote={
      <Stack sx={{ gap: 0.5 }}>
        <Typography variant='caption'>{AI_CONSENT_ON_CONTINUE.line}</Typography>
        <Typography variant='caption'>
          {AI_CONSENT.policyLead}{' '}
          <Link component='button' type='button' variant='caption'>
            {AI_CONSENT.policyLink}
          </Link>
        </Typography>
      </Stack>
    }
    actions={[
      {
        label: 'Continue',
        variant: 'primary',
        onClick: onContinue,
      },
    ]}
  />
);

export default AccessVerifiedConsentScreen;
